$(function() {
  var cache = {};

  $("#disco_codes").autocomplete({
    source: function(request, response) {
      var term = request.term;
      if (term in cache) {
        response(cache[term]);
        return;
      }

      $.getJSON("/danmarks-statistik/disco-codes", request, function(
        data,
        status,
        xhr
      ) {
          console.log(data)
        cache[term] = data;
        response(data);
      });
    },
    minLength: 0
  });

  /*$("#disco_codes").off('focus').on("focus", function(event, ui) {
    var currentTerm = $("#disco_codes").val();
    $("#disco_codes").autocomplete("search", currentTerm);
  });*/
});
